import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=94ccf1c8"
import script from "./approvalRecord.vue?vue&type=script&lang=js"
export * from "./approvalRecord.vue?vue&type=script&lang=js"
import style0 from "./approvalRecord.vue?vue&type=style&index=0&id=94ccf1c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports